module.exports = __webpack_public_path__ + "static/media/logo-blue.3523e643.svg";